import { useAuth } from '@hourly/contexts/AuthContext';
import { ReleaseTogglesProvider } from '@hourly/contexts/ReleaseTogglesContext';
import { RoleActionsProvider } from '@hourly/contexts/RoleActionsContext';
import { Navigate, Outlet } from 'react-router';
import Header from '@shared/components/Header';
import api from '~/api';
import Layout from './components/OnboardingLayout';

export default function OnboardingLayout() {
  const { isLoggedIn, sessionState } = useAuth();

  if (!isLoggedIn) {
    return <Navigate to="/logout" />;
  }

  if (!sessionState.isInOnboarding) {
    return <Navigate to="/referrals" />;
  }

  return (
    <ReleaseTogglesProvider api={api}>
      <RoleActionsProvider api={api}>
        <Layout>
          <Layout.Header>
            <Header name={`${sessionState.firstName} ${sessionState.lastName}`} />
          </Layout.Header>
          <Layout.Body>
            <Outlet />
          </Layout.Body>
        </Layout>
      </RoleActionsProvider>
    </ReleaseTogglesProvider>
  );
}
